import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../../constants";
import { AuthConfig } from "../config/authConfig";
import { canViewFinanceAndCustomers } from "../../util/permissions";

/** Sends users without the permission back to the home page instead of showing a refused page. */
const RequireFullAccess = ({ children }: { children: React.ReactNode }) =>
  canViewFinanceAndCustomers(AuthConfig.getUserInfo()?.authorities) ? (
    <>{children}</>
  ) : (
    <Navigate to={ROUTES.HOME} replace />
  );

export default RequireFullAccess;
